import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="bg-brand-beige py-16 px-4" data-id="element-164">
      <div className="max-w-3xl mx-auto text-center" data-id="element-165">
        <motion.h2 className="text-3xl md:text-5xl font-black text-brand-darkGreen mb-6" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-166">
          <span className="text-4xl mr-2" data-id="element-167">✨</span>
          Este e-book no es solo un recetario
        </motion.h2>

        <motion.p className="text-xl md:text-2xl font-bold text-brand-green mb-10" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-168">
          Es un sistema simple para que:
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-169">
          {['Tengas ideas concretas', 'Cocines más rápido', 'Organices tu semana', 'Y dejes de improvisar todos los días'].map((point, index) => <motion.div key={index} className="bg-white p-6 rounded-xl shadow-md border-l-4 border-brand-green flex items-center gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3 + index * 0.1
        }} data-id="element-170">
              <span className="text-brand-green text-2xl font-bold" data-id="element-171">✔</span>
              <span className="text-lg font-semibold text-brand-darkGreen" data-id="element-172">
                {point}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} data-id="element-173">
          <Button data-id="element-174">QUIERO ORGANIZAR MIS VIANDAS HOY</Button>
        </motion.div>
      </div>
    </section>;
}